
















































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal/modal-config.model";
import { computed, ref, onMounted, Ref } from "@vue/composition-api";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import AdminScope from "./AdminScope.vue";
import { SharedState } from "@/common/state";

export default Vue.extend({
  components: { Modal, DropDownSimple, AdminScope },
  props: ["modalData"],
  setup(props, { emit }) {
    const modified_restrictions: Ref<string[]> = ref([]);
    const is_all_info_types_unchecked = computed(
      () =>
        modified_restrictions.value.reduce((acc, item) => {
          if (item.startsWith("it")) {
            acc++;
          }
          return acc;
        }, 0) === 6
    );

    const is_all_entity_types_unchecked = computed(
      () =>
        modified_restrictions.value.reduce((acc, item) => {
          if (item.startsWith("et")) {
            acc++;
          }
          return acc;
        }, 0) === 5
    );

    const config = computed(() => {
      return {
        title: `Change Admin Role`,
        // @ts-ignore
        desc: "",
        width: "70rem", //current_admin_type.value.id === "business" ? "70rem" : "40rem",
        blank: true,
        withTopRightCloseBtn: true,
      } as ModalConfig;
    });

    const disable_save = computed(
      () =>
        is_all_info_types_unchecked.value || is_all_entity_types_unchecked.value
    );

    const admin_types = ref([
      { id: "system", name: "Super Admin" },
      { id: "business", name: "Business Unit Admin" },
    ]);

    const current_admin_type = ref(admin_types.value[0]);

    const is_different_role = computed(
      // @ts-ignore
      () => current_admin_type.value.id !== props.modalData.role
    );

    const submit = () => {
      const role = current_admin_type.value.id;
      emit("submit", {
        restrictions: role === "business" ? modified_restrictions.value : [],
        role,
      });
    };

    const sys_admin_desc = computed(
      () => SharedState.glossary.value.system_admin.short_desc
    );

    const biz_admin_desc = computed(
      () => SharedState.glossary.value.business_admin.short_desc
    );

    onMounted(() => {
      // @ts-ignore
      modified_restrictions.value = [...props.modalData.restrictions];
    });
    return {
      modified_restrictions,
      config,
      admin_types,
      current_admin_type,
      submit,
      sys_admin_desc,
      biz_admin_desc,
      is_different_role,
      is_all_info_types_unchecked,
      is_all_entity_types_unchecked,
      disable_save,
    };
  },
});
